export const replaceSpaceWithPlusQueryParams = (stringParam: string) => {
  if (stringParam && stringParam.indexOf(" ") >= 0) {
    // String has space, through testing this seems to happen if a + is used
    return stringParam.replace(" ", "+")
  } else {
    return stringParam
  }
}
